import React from 'react';
import PropTypes from 'prop-types';

import { useMousePosition } from '../../../../utils/hooks';
import { useTranslation, Trans } from 'react-i18next';

export default function AttendeeHover({ attendee, seat }) {
    const { t } = useTranslation();
    let { x, y } = useMousePosition();

    const OFFSET_X = 100;
    const OFFSET_Y = 50;
    let xOffset = x + OFFSET_X > window.innerWidth ? -200 : OFFSET_X;
    let yOffset = y + OFFSET_Y + 200 > window.innerHeight ? -200 : OFFSET_Y;

    if (!attendee || !seat) {
        return null;
    }

    return (
        <div
            style={{
                position: 'fixed',
                top: y + yOffset,
                left: x + xOffset,
                zIndex: 4,
                color: '#FFF'
            }}
            className="seat-selector-map"
        >
            <div className="seat-selector-header">
                <Trans
                    i18nKey="seat_info"
                    values={{
                        row: seat.row,
                        seat: seat.seat,
                        access: seat.access
                    }}
                >
                    Access %access% Row %row% Seat %seat%
                </Trans>
            </div>

            <div className="seat-selector-attendee">
                <div className="seat-selector-attendee-name">{attendee.name}</div>
                <div className="seat-selector-attendee-order">
                    <table>
                        <tbody>
                            <tr>
                                <td className="info-description">{t('attendee.info.ticketId')}</td>
                                <td>{attendee.id_weez_ticket}</td>
                            </tr>
                            <tr>
                                <td className="info-description">{t('attendee.order.reference')}</td>
                                <td>{attendee.order.transaction_reference}</td>
                            </tr>
                            <tr>
                                <td className="info-description">{t('attendee.info.category')}</td>
                                <td>{attendee.booking._categoryName}</td>
                            </tr>
                            <tr>
                                <td className="info-description">{t('attendee.info.rate')}</td>
                                <td>{attendee.booking._rateName}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

AttendeeHover.propTypes = {
    attendee: PropTypes.object.isRequired,
    seat: PropTypes.object.isRequired
};
